import { ResultStream } from '@causality/core';
import { CommonError } from '@formunauts/shared/errors/domain';
import { SupporterFeedbackForm } from '@formunauts/supporter-feedback/domain';
import * as Data from 'effect/Data';

export class SupporterFeedbackFormConflictError extends Data.TaggedError(
  'SupporterFeedbackFormConflictError',
) {}

export abstract class SupporterFeedbackFormRepository {
  abstract save(
    request: SupporterFeedbackForm.SaveRequest,
  ): ResultStream.ResultStream<
    SupporterFeedbackForm.SummaryForm,
    SupporterFeedbackFormSaveError
  >;
}

export type SupporterFeedbackFormSaveError =
  | ResultStream.ClientOfflineError
  | ResultStream.ClientTimeoutError
  | CommonError.InfrastructureError
  | CommonError.UnexpectedError
  | SupporterFeedbackFormConflictError;
